export const state = {
  systemactions: []
};

export default {};
